import React from "react";
import { MaskReveal } from "@/components/Reveal";
import { useSEO } from "@/lib/api";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "Are VYRON lenses UV protected?", a: "Every frame ships with UV400 lenses, blocking 100% of UVA and UVB rays. Polarised options are available on select silhouettes." },
  { q: "What is your shipping timeline within India?", a: "Orders are dispatched within 24 hours and delivered in 2–4 business days across India, fully insured and free of charge." },
  { q: "Do you ship internationally?", a: "Yes. We ship worldwide with tracked, insured delivery. International duties are calculated at checkout where applicable." },
  { q: "What is your returns and warranty policy?", a: "Enjoy 30-day returns on unworn frames and a 2-year warranty covering manufacturing defects. Reach our concierge to initiate either." },
  { q: "How do I choose the right fit?", a: "Each product page lists frame dimensions. Our concierge team is happy to recommend a silhouette — simply write to vyronofficial6@gmail.com." },
  { q: "Which payment methods do you accept?", a: "We accept all major cards, UPI and netbanking via Razorpay, as well as international cards through Stripe. Every transaction is fully secured." },
  { q: "Can I track my order?", a: "Absolutely. Visit the Track Order page and enter your order number and email to see live status updates." },
];

export default function FAQ() {
  useSEO("FAQ", "Answers to common questions about VYRON eyewear — shipping, returns, warranty, payments and fit.");
  return (
    <div data-testid="faq-page" className="pt-32 pb-28">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-5">Answers</p>
        <h1 className="font-display text-6xl md:text-8xl tracking-[-0.03em] leading-[0.85] mb-14">
          <MaskReveal>Frequently asked.</MaskReveal>
        </h1>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-black/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display text-xl md:text-2xl tracking-tight py-7 hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-7 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
